function pushFocusToElement(whichElement) {
    const element = document.getElementById(whichElement);
    if(element) {
        window.setTimeout(function() {
            element.focus();
        }, 0);
    }
}

export default pushFocusToElement;